import React, { useState, useEffect } from 'react';

import { useTheme } from 'styled-components';

import { FaFileExcel } from 'react-icons/fa';
import { FaFilePdf } from 'react-icons/fa';
import { IoMdArrowDropup, IoMdArrowDropdown } from 'react-icons/io';
import { FaTag } from 'react-icons/fa';
import { FaMapMarkerAlt } from 'react-icons/fa';

import api from '~/services/api';

import { exportCsv } from '~/helpers/csv';
import { exportPdf } from '~/helpers/pdf';

import {
  Scroll,
  Container,
  Header,
  Progress,
  Loading,
  Grid,
  GridLine,
  GridHeadItem,
  GridItem,
} from '~/components';

import { GraphArea, LoadArea, Tags, ToogleInfo } from './styles';

import Grafico from './Grafico';

import RelatorioVendaUf from '~/@types/relatoriovendauf';
import RelatorioVendaUfEstado from '~/@types/RelatorioVendaUfEstado';
import { ProgressTag } from '../Dashboard/styles';

const VendasPorEstado: React.FC = () => {
  const { colors } = useTheme();

  const [inLoad, setInLoad] = useState(false);

  const [vendasuf, setVendasuf] = useState<RelatorioVendaUf[]>([]);
  const [vendasUfVisibilidade, setGraficoVisibilidade] = useState(true);
  const [moduloGrafico, setModuloGrafico] = useState('hoje');

  // MODULO (VENDAS POR UF)
  const filtrarUfsPorModulo = (
    pModuloGrafico: string,
    pGraficos: RelatorioVendaUf[],
  ) => {
    const ufs: RelatorioVendaUfEstado[] = [];

    let c;
    for (c in pGraficos) {
      const relatorio = pGraficos[c];
      if (relatorio.nome === pModuloGrafico) {
        let d;
        for (d in relatorio.ufs) {
          const uf = relatorio.ufs[d];
          ufs.push(uf);
        }
      }
    }

    return ufs;
  };

  const gerarRelatorioGraficoCSV = () => {
    let data: string[] = [];

    data.push('ESTADO;PEDIDOS;PRODUTOS;FRETE;DESCONTO;TICKETMEDIO;TOTAL');

    const ufs = filtrarUfsPorModulo(moduloGrafico, vendasuf);

    let d;
    for (d in ufs) {
      const uf = ufs[d];

      data.push(
        `${uf.nome};${uf.pedidos};${uf.produtos};${uf.frete};${uf.desconto};${uf.ticketmedio};${uf.total}`,
      );
    }

    const csv = data.join('\n');

    exportCsv(csv, `VENDAS UF - ${moduloGrafico.toUpperCase()}`);
  };

  const gerarRelatoriosGraficoPDF = () => {
    const cabecalho = [
      'ESTADO',
      'PEDIDOS',
      'PRODUTOS',
      'FRETE',
      'DESCONTO',
      'TICKETMEDIO',
      'TOTAL',
    ];

    const data: string[][] = [];

    const ufs = filtrarUfsPorModulo(moduloGrafico, vendasuf);

    let d;
    for (d in ufs) {
      const uf = ufs[d];

      const linha: string[] = [];

      linha.push(`${uf.nome}`);
      linha.push(`${uf.pedidos}`);
      linha.push(`${uf.produtos}`);
      linha.push(`${uf.frete}`);
      linha.push(`${uf.desconto}`);
      linha.push(`${uf.ticketmedio}`);
      linha.push(`${uf.total}`);

      data.push(linha);
    }

    exportPdf(cabecalho, data, `VENDAS UF - ${moduloGrafico.toUpperCase()}`);
  };

  const exibicaoTotalPedidos = (pTotalPedidos: number) => {
    if (!pTotalPedidos) return 'Nenhum pedido';
    if (pTotalPedidos === 1) {
      return 'Um pedido';
    }
    return `${pTotalPedidos} pedidos`;
  };

  useEffect(() => {
    const fetchVendasPorUf = async () => {
      try {
        setInLoad(true);
        setVendasuf([]);

        const ano = new Date().getFullYear();
        const modulo = 'vendas_por_uf';

        const response = await api.get(
          `relatorios?ano=${ano}&modulo=${modulo}`,
        );

        const { data } = response;

        if (data && Array.isArray(data) && data.length) {
          setVendasuf(data);
        }

        setInLoad(false);
      } catch (e) {
        setInLoad(false);
      }
    };
    fetchVendasPorUf();
  }, []);

  return (
    <>
      {inLoad ? <Progress /> : null}

      <Scroll>
        <Container>
          <Header
            title="Vendas por estado"
            subtitle="Confira as métricas de vendas distribuídas por estado"
            icon={
              <>
                <FaMapMarkerAlt size={32} color={colors.IC1} />
              </>
            }
          />

          {inLoad ? (
            <LoadArea>
              <Loading color={colors.IC1} size={42} />
            </LoadArea>
          ) : null}

          {vendasuf.length ? (
            <GraphArea>
              <header>
                <i>
                  <FaMapMarkerAlt size={26} color={colors.IC1} />
                </i>
                <p>
                  <h1>Vendas por estado</h1>
                  <h2>Confira as métricas de vendas distribuídas por estado</h2>
                </p>

                <div>
                  <button
                    className="excel"
                    onClick={gerarRelatorioGraficoCSV}
                    title="Exportar para Excel"
                  >
                    <FaFileExcel size={22} color={colors.IC2} />
                    <div>
                      <h3>EXPORTAR</h3>
                      <h2>EXCEL</h2>
                    </div>
                  </button>
                  <button
                    className="pdf"
                    onClick={gerarRelatoriosGraficoPDF}
                    title="Exportar para PDF"
                  >
                    <FaFilePdf size={22} color={colors.IC2} />
                    <div>
                      <h3>EXPORTAR</h3>
                      <h2>PDF</h2>
                    </div>
                  </button>
                </div>
              </header>

              <Tags>
                <div>
                  <button
                    className={moduloGrafico === 'hoje' ? 'active' : ''}
                    onClick={() => setModuloGrafico('hoje')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Hoje</span>
                  </button>
                  <button
                    className={
                      moduloGrafico === 'ultimos-7-dias' ? 'active' : ''
                    }
                    onClick={() => setModuloGrafico('ultimos-7-dias')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Últimos 7 Dias</span>
                  </button>
                  <button
                    className={moduloGrafico === 'mes-atual' ? 'active' : ''}
                    onClick={() => setModuloGrafico('mes-atual')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Mês Atual</span>
                  </button>
                  <button
                    className={moduloGrafico === 'mes-passado' ? 'active' : ''}
                    onClick={() => setModuloGrafico('mes-passado')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Mês Passado</span>
                  </button>
                  <button
                    className={moduloGrafico === 'ano-atual' ? 'active' : ''}
                    onClick={() => setModuloGrafico('ano-atual')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Ano Atual</span>
                  </button>
                  <button
                    className={moduloGrafico === 'ano-passado' ? 'active' : ''}
                    onClick={() => setModuloGrafico('ano-passado')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Ano Passado</span>
                  </button>
                </div>
              </Tags>

              <main>
                <div>
                  <Grafico ufs={filtrarUfsPorModulo(moduloGrafico, vendasuf)} />
                </div>
              </main>

              <footer>
                {vendasUfVisibilidade ? (
                  <Grid>
                    <GridLine>
                      <GridHeadItem title="Estado" />
                      <GridHeadItem title="Pedidos" width={150} />
                      <GridHeadItem title="Produtos" width={150} />
                      <GridHeadItem title="Frete" width={150} />
                      <GridHeadItem title="Desconto" width={150} />
                      <GridHeadItem title="Total" width={150} />
                      <GridHeadItem title="Ticket Médio" width={150} />
                    </GridLine>

                    {filtrarUfsPorModulo(moduloGrafico, vendasuf).map(uf => (
                      <GridLine key={uf.nome}>
                        <GridItem>{uf.nome}</GridItem>
                        <GridItem width={150}>
                          <div>{exibicaoTotalPedidos(uf.pedidos)}</div>
                          <ProgressTag>{uf.pedidos_porcentagem}%</ProgressTag>
                        </GridItem>
                        <GridItem width={150}>
                          {uf.produtos.toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL',
                          })}
                        </GridItem>
                        <GridItem width={150}>
                          {uf.frete.toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL',
                          })}
                        </GridItem>
                        <GridItem width={150}>
                          {uf.desconto.toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL',
                          })}
                        </GridItem>

                        <GridItem width={150}>
                          <div>
                            {uf.total.toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL',
                            })}
                          </div>
                          <ProgressTag>
                            {uf.faturamento_porcentagem}%
                          </ProgressTag>
                        </GridItem>
                        <GridItem width={150}>
                          {uf.ticketmedio.toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL',
                          })}
                        </GridItem>
                      </GridLine>
                    ))}
                  </Grid>
                ) : null}
                <ToogleInfo
                  onClick={() => setGraficoVisibilidade(!vendasUfVisibilidade)}
                >
                  {vendasUfVisibilidade ? (
                    <IoMdArrowDropup size={32} color={colors.IC1} />
                  ) : (
                    <IoMdArrowDropdown size={32} color={colors.IC1} />
                  )}
                </ToogleInfo>
              </footer>
            </GraphArea>
          ) : null}
        </Container>
      </Scroll>
    </>
  );
};

export default VendasPorEstado;
